module.exports = __webpack_public_path__ + "static/img/green_animate3.9e570fb2.png";